import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { App } from '@capacitor/app';
import { AlertController, MenuController, Platform } from '@ionic/angular';
import { register } from 'swiper/element/bundle';
import { FcmFirebaseProvider } from './provider/fcmFirebase.provider';
import { OneSignalProvider } from './provider/oneSignal.provider';
import { GoogleAnalyticsService } from './services/analitytics-service/google-analytics.service';
import { ModelLocatorService } from './services/config/model-locator.service';
import { OnboardService } from './services/config/onboard.service';
import { RemoteConfigService } from './services/config/remote-config.service';
import { MenuService } from './services/menu-service/menu.service';
import { MessageService } from './services/message-service/message.service';
import { UpdateAppOtaService } from './services/update/update-app.service';
import { CapacitorUpdater } from '@capgo/capacitor-updater';

register();

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
})
export class AppComponent {

    public url: string = '';
    public mostraMenu: string = '';
    pushes: any = [];

    versionApp: any;
    bundleVersion: string = '';


    /** Menu Principal */
    public menuPrincial = [
        {
            route: '/home',
            icon: { src: '../../assets/icon/icone_interacao.svg' },
            label: 'INTERAÇÃO',
            condition: 'interacao',
            disabled: false,
            hidden: false
        },
        {
            route: '/store',
            icon: { name: 'gift-outline', class: 'icon-logout' },
            label: 'LOJA',
            condition: 'premiacao',
            disabled: false,
            hidden: false
        },
        // {
        //     route: '/benefits',
        //     icon: { src: '../../assets/icon/icone_beneficios.svg' },
        //     label: 'BENEFÍCIOS',
        //     condition: 'beneficios',
        // disabled: false,
        // hidden: false
        // },
        // {
        //     route: '/multi-awards',
        //     icon: { src: '../../assets/icon/icone_superacao.svg' },
        //     label: 'MULTIPREMIOS',
        //     condition: 'multipremios',
        // disabled: false,
        // hidden: false
        // },
        {
            route: '/information',
            icon: { src: '../../assets/icon/icone_informacao.svg' },
            label: 'INFORMAÇÃO',
            condition: 'informacao',
            disabled: false,
            hidden: false
        },
        {
            route: '/faq',
            icon: { src: '../../assets/icon/icone_faq.svg' },
            label: 'FAQ',
            condition: 'faq',
            disabled: false,
            hidden: false
        },
        {
            route: '/plans',
            icon: { name: 'information-circle-outline', class: 'icon-logout' },
            label: 'PONTUAÇÃO',
            condition: 'planos',
            disabled: false,
            hidden: false
        },
        {
            route: '/help',
            icon: { src: '../../assets/icon/icone_suporte.svg' },
            label: 'SUPORTE',
            condition: 'suporte',
            disabled: false,
            hidden: false
        }
    ];

    /** Menu Usuário */
    public menuUsuario = [
        {
            route: '/profile',
            icon: { src: '../../assets/icon/icone_perfil_quadrado.svg' },
            label: 'Meu Perfil',
            condition: 'perfil',
            disabled: false,
            hidden: false
        },
        // {
        //     route: '/activation-pre',
        //     icon: { src: '../../assets/icon/icone_ativacao.svg' },
        //     label: 'Pré Pago',
        //     condition: 'pre',
        // disabled: false,
        // hidden: false
        // },
        {
            route: '/activation-list',
            icon: { src: '../../assets/icon/icone_ativacao.svg' },
            label: 'Minhas Ativações',
            condition: 'ativacoes',
            disabled: false,
            hidden: false
        },
        // {
        //     route: '/quality',
        //     icon: { name: 'analytics', class: 'icon-logout' },
        //     label: 'Minha Qualidade',
        //     condition: 'qualidade',
        // disabled: false,
        // hidden: false
        // },
        {
            route: '/wallet',
            icon: { src: '../../assets/icon/icone_extrato.svg' },
            label: 'Minha Carteira',
            condition: 'carteira',
            disabled: false,
            hidden: false
        },
        {
            route: '/extract',
            icon: { src: '../../assets/icon/icone_extrato.svg' },
            label: 'Meu Extrato',
            condition: 'extrato',
            disabled: false,
            hidden: false
        },
        {
            route: '/my-rescue',
            icon: { name: 'gift', class: 'icon-logout' },
            label: 'Meus Resgates',
            condition: 'resgates',
            disabled: false,
            hidden: false
        },
        {
            route: '/challenges/list-of-challenges',
            icon: { src: '../../assets/icon/icone_superacao.svg' },
            label: 'Meus Desafios',
            condition: 'desafios',
            disabled: false,
            hidden: false
        },
        {
            route: '/team',
            icon: { name: 'people', class: 'icon-logout' },
            label: 'Minha Equipe',
            condition: 'team',
            disabled: false,
            hidden: false
        }
        // {
        //     route: '/uploads',
        //     icon: { name: 'cloud-upload', class: 'icon-logout' },
        //     label: 'Meus Uploads',
        //     condition: 'uploads',
        // disabled: false,
        // hidden: false
        // },
    ];


    constructor(
        public modelLocator: ModelLocatorService,
        private platform: Platform,
        // private androidService: AndroidService,
        private router: Router,
        private fcmFirebaseProvider: FcmFirebaseProvider,
        private oneSignalProvider: OneSignalProvider,
        private analytics: GoogleAnalyticsService,
        private alertController: AlertController,
        private menuCtrl: MenuController,
        // private menuCtrl: MenuController,
        private messageService: MessageService,
        private onboardService: OnboardService,
        private remoteConfigService: RemoteConfigService,
        private menuService: MenuService,
        private updateAppOtaService: UpdateAppOtaService
    ) {
        this.initializeApp();
    }

    async initializeApp() {
        await this.platform.ready().then(async () => {
            this.menuCtrl.enable(false, 'end');
            this.menuCtrl.enable(false, 'start');
            await this.fcmFirebaseProvider.getToken();
            await this.oneSignalProvider.setupPushOneSignal();
            await this.analytics.startAnalytics();
            await this.remoteConfigService.checkRemoteUpdateVersion();

            await this.setConfigMenu();
            await this.getDeviceInfo();
            await CapacitorUpdater.notifyAppReady();
            this.bundleVersion = await this.updateAppOtaService.getCurrentBundleVersion();
        });
    }

    async setConfigMenu() {
        setTimeout(async () => {
            this.menuPrincial = await this.menuService.disableOrHiddenMenu(this.menuPrincial);
            this.menuUsuario = await this.menuService.disableOrHiddenMenu(this.menuUsuario);
        }, 5000)

    }

    closeMenu() {
        this.setConfigMenu();
        this.menuCtrl.close();
    }

    /**
     * Gets condition
     * @author Starley Cazorla
     * @param menuItem
     * @returns true if condition
     */
    getCondition(menuItem: string): boolean {
        return this.modelLocator.menu[menuItem];
    }


    async touchLogout() {

        const alert = await this.alertController.create({
            header: 'Atenção!',
            message: 'Você deseja realmente sair?',
            mode: 'md',
            buttons: [
                {
                    text: 'Não',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {

                    }
                }, {
                    text: 'Sim',
                    handler: () => {
                        this.modelLocator.logado = false;
                        localStorage.clear();
                        this.modelLocator.urlretorno = '';
                        this.router.navigate(['/login']);
                    }
                }
            ]
        });

        await alert.present();
    }

    async getDeviceInfo() {
        if (this.platform.is('cordova')) {
            const appData = App.getInfo();
            this.versionApp = (await appData).version
        } else {
            this.versionApp = this.modelLocator.version
        }
    }


    async tutorial(etapa: number) {

        if (etapa === 1) {
            this.modelLocator.balao_1 = false;
            this.modelLocator.balao_2 = true;
            this.router.navigate(['/plans']);
        }

        if (etapa === 2) {
            this.modelLocator.balao_2 = false;
            this.modelLocator.balao_3 = true;
            this.router.navigate(['/challenges/list-of-challenges']);
        }

        if (etapa === 3) {
            this.modelLocator.balao_3 = false;
            this.modelLocator.balao_4 = true;
            this.router.navigate(['/activation-list']);
        }

        if (etapa === 4) {
            this.modelLocator.balao_4 = false;
            this.router.navigate(['/home']);
            await this.gravaNavegacao();
        }

    }

    async touchPopUpChallenge(etapa: number) {
        if (etapa === 1) {
            this.modelLocator.popup_challenge_1 = false;
            this.modelLocator.popup_challenge_2 = true;
            this.router.navigate(['/plans']);
        }

        if (etapa === 2) {
            this.modelLocator.popup_challenge_2 = false;
            this.modelLocator.popup_challenge_3 = true;
            this.router.navigate(['/challenges/list-of-challenges']);
        }

        if (etapa === 3) {
            this.modelLocator.popup_challenge_3 = false;
            this.modelLocator.popup_challenge_4 = true;
            this.router.navigate(['/activation-list']);
        }

        if (etapa === 4) {
            this.modelLocator.popup_challenge_4 = false;
            this.router.navigate(['/home']);
            await this.gravaNavegacaoDesafio();
        }
    }

    /**
     * Gravas navegacao
     * @author Starley Cazorla
     */
    async gravaNavegacao() {

        const credenciais: any = {
            cpf: this.modelLocator.dadosLogin.cpf
        };

        await this.onboardService.saveOnboard(credenciais).then((data: any) => {
            if (data['status'] === 200 || data['status'] === 402) {
                this.modelLocator.dadosLogin.navegacao = true;
            } else {
                this.messageService.showToast('Erro ao gravar navegação. ' + data['message'], 'warning', 'bottom', 5000, true);
            }
        }).catch((error) => {
            this.messageService.showToast('Erro ao gravar navegação. ' + error['error'].message, 'warning', 'bottom', 5000, true);
        });
    }

    /**
     * Gravas navegacao desafio
     * @author Starley Cazorla
     */
    async gravaNavegacaoDesafio() {

        const credenciais: any = {
            cpf: this.modelLocator.dadosLogin.cpf
        };

        await this.onboardService.saveOnboardChallenge(credenciais).then((data: any) => {
            if (data['status'] === 200) {
                this.modelLocator.dadosLogin.navegacao_desafio = true;
            } else {
                this.messageService.showToast('Erro ao gravar navegação. ' + data['message'], 'warning', 'bottom', 5000, true);
            }
        }).catch((error) => {
            this.messageService.showToast('Erro ao gravar navegação. ' + error['error'].message, 'warning', 'bottom', 5000, true);
        });
    }

}
